import FupOrganisationListModelBase from '../_generated/modelBases/fup-organisation-list-model-base';

export default class FupOrganisationListModel extends FupOrganisationListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
